
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
  import {
    materialrelationProductItem,
    materialHairRingMaterialmaterialHairRingMaterialSave,
    materialHairRingMaterialmaterialHairRingMaterialInfo
  } from "@/api/material"
  @Component({  
    name: '',
    components: {
      PageFooter,
      UploadImg
    }
  })

  export default class ProductList extends Vue {
    private pageloading = false
    private form:any = {
      Id:0,
      ProductId:null,
      Copywriting:'',
      Sort:'',
      MaterialType:0,
      ImgUrlList:[],
      VideoUrl:'',
      VideoUrllist:[],
      ThumbImgUrl:'',
      ThumbImgUrllist:[]
    }
    private ProductIdList:any = []
    private uploadmsg:any = {
      fileType:'image',
      tips:'注：图片大小不超过5M; 支持jpg,png文件',
      limit:9,
      size_limit:5,
      list:'ImgUrlList'
    }

    private mounted () {
      if(Number(this.$route.query.Id)){
        this.getinfo()
      }else{
        this.getshopList()
      }
    }


    private infotype(){
      if(this.form.MaterialType==0){
        this.uploadmsg = {
          fileType:'image',
          tips:'注：图片大小不超过5M; 支持jpg,png文件',
          limit:9,
          size_limit:5,
          list:'ImgUrlList'
        }
      }else{
        this.uploadmsg = {
          fileType:'video',
          tips:'建议使用16:9比例视频；视频大小控制在100M以内',
          limit:1,
          size_limit:100,
          list:'VideoUrl'
        }
      }
    }
    private changetype(e){
      // console.log(e)
      this.form.ImgUrlList = []
      this.form.VideoUrllist = []
      this.infotype()
      
    }
    private goback(){
      this.$router.go(-1)
    }
    private testform(){
      let form = JSON.parse(JSON.stringify(this.form))
      if(!form.Copywriting){
        this.$message.error('请输入素材文案')
        return false
      }
      if(form.MaterialType==0){
        if(!form.ImgUrlList||!form.ImgUrlList.length){
          this.$message.error('至少上传一张素材图')
          return false
        }
      }else{
        if(!form.VideoUrllist||!form.VideoUrllist.length){
          this.$message.error('请上传视频素材')
          return false
        }
        if(!form.ThumbImgUrllist||!form.ThumbImgUrllist.length){
          this.$message.error('请上传封面图')
          return false
        }
      }
      return true
    }
    private async save(){
      if(!this.testform()){
        return
      }

      try{
        let data = JSON.parse(JSON.stringify(this.form))
        data.Sort = data.Sort || 0
        if(data.MaterialType==1){
          data.VideoUrl = data.VideoUrllist[0]
          data.ThumbImgUrl = data.ThumbImgUrllist[0]
          data.ImgUrlList = []
        }else{
          data.VideoUrl = ''
          data.ThumbImgUrl = []
        }
        let res = await materialHairRingMaterialmaterialHairRingMaterialSave({
          Info:data
        })
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.goback()
        }
      }finally{
        //
      }
    }
    private uploadSuc2(list){
      this.form.ThumbImgUrllist = list
    }
    private uploadSuc(list){
      // console.log(list)
      if(this.form.MaterialType==0){
        this.form.ImgUrlList = list
      }else{
        // this.form.VideoUrl = list[0]
        this.form.VideoUrllist = list
      }
    }
    private async getshopList(){
      try{
        let res = await materialrelationProductItem({})
        if(res.IsSuccess){
          this.ProductIdList = res.Result
        }
      }finally{
        //
      }
    }
    private async getinfo(){
      try{
        let res = await materialHairRingMaterialmaterialHairRingMaterialInfo({
          Id:this.$route.query.Id
        })
        if(res.IsSuccess){
          this.form = res.Result
          if(this.form.MaterialType==1){
            this.form.VideoUrllist = [this.form.VideoUrl]
            this.form.ThumbImgUrllist = [this.form.ThumbImgUrl]
          }
          this.infotype()
          await this.getshopList()
          // console.log(this.ProductIdList,this.form)
          if(this.form.ProductId==0){
            this.form.ProductId = ''
          }else if(!this.ProductIdList.find(v=>v.Id==this.form.ProductId)?.Id){
            this.ProductIdList.push({
              Id:this.form.ProductId,
              ProductName:this.form.ProductName,
            })
          }
          // console.log(!this.ProductIdList.find(v=>v.Id==this.form.ProductId)?.Id)
        }
      }finally{
        //
      }
    }

  }
